var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34427",
    "data-name": "Group 34427",
    transform: "translate(13716 18937)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10185",
    "data-name": "Rectangle 10185",
    width: 18,
    height: 18,
    transform: "translate(-13716 -18937)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33553",
    "data-name": "Group 33553",
    transform: "translate(21 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71803",
    "data-name": "Path 71803",
    d: "M82,60h1.235v3.088H82Z",
    transform: "translate(-13812.883 -18990.941)",
    fill: "#5076ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71804",
    "data-name": "Path 71804",
    d: "M72.706,55.971H65.294V51.235h7.412ZM69,61.324a2.059,2.059,0,1,1,2.059-2.059A2.065,2.065,0,0,1,69,61.324ZM75.176,50H64.059L62,52.059V63.176a.826.826,0,0,0,.824.824H75.176A.826.826,0,0,0,76,63.176V50.824A.826.826,0,0,0,75.176,50Z",
    transform: "translate(-13797 -18983)",
    fill: "#5076ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71805",
    "data-name": "Path 71805",
    d: "M93,92h1.235v1.235H93Z",
    transform: "translate(-13821.617 -19016.354)",
    fill: "#5076ba"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/save-icon.e388fb693ac6bfdd60cf59bbd389db62.svg";
export { ForwardRef as ReactComponent };